import  { useState } from 'react';
import './ShopDetailsTab.css'; 
const ShopDetailsTab = ({ onTabChange }) => {
  // 定义标签页数据
  const tabs = [
    { id: 'day', label: '日报' },
    { id: 'week', label: '周报' },
    { id: 'month', label: '月报' },
    { id: 'quarter', label: '季度报' },
    { id: 'year', label: '年报' }
  ];
  
  // 当前激活的标签页状态 
  const [activeTab, setActiveTab] = useState(tabs[0].id);
  
  // 处理标签页切换
  const handleTabChange = (tabId) => {
    console.log('切换标签页：', tabId);
    onTabChange(tabId);
    setActiveTab(tabId);
  };
  return (
    <div className="tab-container">
      
      <div className="tab-controls" role="tablist">
        {tabs.map((tab)  => (
          <button
            key={tab.id} 
            className={`tab-button ${activeTab === tab.id  ? 'active' : ''}`}
            onClick={() => handleTabChange(tab.id)} 
            role="tab"
            aria-selected={activeTab === tab.id} 
          >
            {tab.label} 
          </button>
        ))}
      </div>
    </div>
  );
};
export default ShopDetailsTab;
